import { Box, Typography, useMediaQuery } from '@mui/material';
import { MRT_ColumnDef } from 'mantine-react-table';
import React, { useMemo } from 'react';
import { MailingListUser } from '../../../../types/user';
import GenericTable from '../../../../shared/GenericTable';
import { dashboardItemsTableDefaults } from '../../../Dashboard/dashboardReportTableConfig';

type MailingListReportListProps = {
    data?: MailingListUser[];
    userTypeLabel: string;
};

export default function MailingListReportList({
    data,
    userTypeLabel,
}: MailingListReportListProps) {
    const isMobile = useMediaQuery('(max-width: 770px)');

    const rows = data ?? [];

    const columns: MRT_ColumnDef<MailingListUser>[] = useMemo(
        () => [
            {
                accessorKey: 'id',
                header: 'ID',
                size: 90,
            },
            {
                accessorKey: 'email',
                header: 'Email',
                size: 200,
            },
            {
                accessorKey: 'firstName',
                header: 'First Name',
                size: 130,
            },
            {
                accessorKey: 'lastName',
                header: 'Surname',
                size: 130,
            },
            {
                accessorKey: 'role',
                header: 'Role',
                size: 130,
            },
            {
                accessorKey: 'companyName',
                header: 'Company',
                size: 180,
            },
        ],
        [],
    );

    if (!rows.length) {
        return (
            <Typography sx={{ mt: 4 }} variant='body2'>
                No Mailing Lists users found.
            </Typography>
        );
    }

    return (
        <Box
            sx={{
                width: isMobile ? '90vw' : '100%',
            }}
        >
            <GenericTable
                {...dashboardItemsTableDefaults}
                columns={columns}
                data={rows}
                tableName={`Mailing Lists - ${userTypeLabel}`}
                paginationItemLabel='users'
            />
        </Box>
    );
}
